import { find, isFunction, remove } from 'lodash-es'

import { CategoryAPI, ProductAPI } from 'src/api'

export default {
  state: {
    categoriesList: [],
    categories: {},
    categoryOrder: [],
  },
  mutations: {
    ADD_CATEGORY(state, payload) {
      const category = {
        price: 0,
        products: [],
        ...payload,
      }

      const categories = state.categories
      const categoriesList = state.categoriesList
      const categoryOrder = state.categoryOrder
      const isHasOrdinal = payload.ordinal === 0 || payload.ordinal

      if (!categoriesList) {
        return
      }
      if (!categories) {
        state.categories = {}
      }

      state.categories[payload.id] = {
        ...category,
      }
      if (isHasOrdinal) {
        state.categoryOrder = [
          ...categoryOrder.slice(0, payload.ordinal),
          payload.id,
          ...categoryOrder.slice(payload.ordinal, categoryOrder.length),
        ]
      } else {
        state.categoryOrder = [...categoryOrder, payload.id]
      }
      categoriesList.push({
        ...category,
        name: category.title,
      })
    },
    REMOVE_CATEGORY(state, { id }) {
      const categoryOrder = [...state.categoryOrder]
      remove(categoryOrder, (item) => id === item)
      state.categoryOrder = categoryOrder
    },
    UPDATE_CATEGORY(state, { id, payload }) {
      const category = state.categories[id]
      if (category) {
        if (isFunction(payload)) {
          state.categories[id] = payload(category)
        } else {
          state.categories[id] = {
            ...category,
            ...payload,
          }
        }
      }
    },
    SET_CATEGORIES_RTB(state, payload) {
      state.rtb.categories = payload
    },
    SET_CATEGORIES_LIST(state, payload) {
      state.categoriesList = payload
    },
    SET_CATEGORIES(state, payload) {
      state.categories = payload.entities
      state.categoryOrder = payload.result
    },
  },
  actions: {
    async addCategory({ commit, state, dispatch, getters }, body) {
      const { name, color } = body
      const category = find(state.categoriesList, {
        name,
      })
      const addCategoryBody = {
        title: name,
        color,
        dealerShips: getters.dealerships.reduce((acc, item) => {
          acc[item.id] = {
            targetBudget: 0,
            actualBudget: 0,
          }
          return acc
        }, {}),
      }
      if ((state, category)) {
        const { productCategoryId } = category
        let ordinal

        if (state.categories) {
          const data = await dispatch('updateCategory', {
            id: productCategoryId,
            body,
          })
          ordinal = data.ordinal
        }

        commit('ADD_CATEGORY', {
          ...addCategoryBody,
          ordinal,
          id: productCategoryId,
          categoryType: 'category',
        })
      } else {
        const newCategory = await CategoryAPI.create({ ...body })
        const { productCategoryId } = newCategory
        commit('ADD_CATEGORY', {
          ...addCategoryBody,
          id: productCategoryId,
        })
      }
    },
    async moveCategory(_, { ordinal, productCategoryId }) {
      await CategoryAPI.move({ ordinal: ordinal - 1, productCategoryId })
    },

    async moveProduct(_, { ordinal, productCategoryId, productId }) {
      await ProductAPI.move({ ordinal: ordinal - 1, productCategoryId, productId })
    },

    async updateCategory({ commit }, { id, body }) {
      if (!id) {
        return
      }
      const data = await CategoryAPI.update({
        ...body,
        id,
        productCategoryId: id,
      }).then((data) => {
        if (data) {
          commit('UPDATE_CATEGORY', {
            id,
            payload: {
              title: body.name,
              ...body,
            },
          })
        } else {
          /* TODO: RAISE ERROR MODAL */
        }

        return data
      })
      return data
    },
    getCategories({ commit }) {
      return CategoryAPI.getList({ withProducts: true }).then((data) => {
        const categories = data
        commit('SET_CATEGORIES_LIST', categories)
        commit(
          'SET_PRODUCTS_LIST',
          categories.reduce((acc, item) => acc.concat(item.products), [])
        )
      })
    },
  },
  getters: {
    getCategory: (state) => (id) => (state.categories ? state.categories[id] : {}),
  },
}
